import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import vueDebounce from 'vue-debounce'
import {createPinia} from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
const app = createApp(App);
app.use(vuetify);
app.use(router);
app.use(pinia)
app.directive('debounce', vueDebounce({ lock: true }))
app.mount('#app')
